import BANKS_JSON from '../constants/banks';

const getBanks = () => Promise.resolve({ data: BANKS_JSON });

export default { getBanks };
